export default __webpack_public_path__ + "static/media/talk.74a2e030.jpg";